import { render, staticRenderFns } from "./ConstructionComponent.vue?vue&type=template&id=24945d34"
import script from "./ConstructionComponent.vue?vue&type=script&lang=js"
export * from "./ConstructionComponent.vue?vue&type=script&lang=js"
import style0 from "./ConstructionComponent.vue?vue&type=style&index=0&id=24945d34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports